import { render } from "./principalStudio.vue?vue&type=template&id=12fab697&scoped=true"
import script from "./principalStudio.vue?vue&type=script&lang=js"
export * from "./principalStudio.vue?vue&type=script&lang=js"

import "./principalStudio.vue?vue&type=style&index=0&id=12fab697&scoped=true&lang=css"

import exportComponent from "E:\\edu-ui\\JzEducationAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-12fab697"]])

export default __exports__